/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
var a;!function(a){a[a.Bind=0]="Bind",a[a.Pass=1]="Pass",a[a.Draw=2]="Draw"}(a||(a={}));export{a as BindType};
